<template>
  <div class="w-100 bg-white p-12" :class="!loading && 'disable-ske'">
    <div class="d-flex justify-content-between static-responsive">
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <p class="detail text-center">Klantnaam</p>
        <span class="bold m-2 ske p-1">{{ `${customer && customer.firstName} ${customer && customer.lastName}` }}</span>
      </div>
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <p class="detail text-center">Ordernummer</p>
        <span class="bold m-2 ske p-1">{{ orderNumber || "---" }}</span>
      </div>
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <p class="detail text-center">Order datum</p>
        <span class="bold m-2 ske p-1">{{ formatDate || '---' }}</span>
      </div>
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <p class="detail text-center">Order totaalbedrag</p>
        <span class="bold m-2 ske p-1">€{{ totalPrice ? totalPrice.toFixed(2) : "---" }}</span>
      </div>
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <p class="detail text-center">Aantal producten</p>
        <span class="bold m-2 ske p-1">{{ (orders && orders.length) || "---" }}</span>
      </div>
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <p class="detail text-center">Berichten</p>
        <span class="bold m-2 ske p-1">{{ "---" }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import { format } from 'date-fns'

export default {
  props: ['customer', 'orderNumber', 'orderDate', 'orders', 'loading'],
  data() {
    return {
    }
  },
  computed: {
    totalPrice() {
      return this.orders ? this.orders.reduce((tot, curr) => tot + parseFloat((curr.price + '').replace(',', '.')) * parseInt(curr.qty, 10), 0) : 0
    },
    formatDate() {
      const date = this.orderDate
      try {
        return date && format(new Date(date), "dd-MM-yyyy")
      } catch (err) {
        return date
      }
    },
  },
}
</script>

<style scoped>

p {
  margin-bottom: 4px;
}

.bg-white {
  background-color: #ffffff !important;
}
.bold{
  font-size: large;
  font-weight: 700;
}
.detail{
  color: #6D6E71;
}
.date-head{
  width: 27px;
  margin: 0px;
  margin-right: 5px;
  padding-right: 5px;
  border-right: 1px solid #6D6E71;
}
.date-picker-shadow{
  box-shadow: 1px 1px 3px 0px #00000030;
}

.static-responsive {
  padding: 14px 55px;
}

@media screen and (max-width: 900px) {
  .static-responsive{
    display: flex;
    flex-direction: column;
  }
}
</style>
